import styled from 'styled-components';

const TabHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const ChipContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export {
  ChipContainer,
  TabHeaderRow,
};
